import { Platform } from "@ionic/angular";

export class StringUtils {
    // this function is used to check if the running platform is mobile or not
    static isMobilePlatform(platform: Platform): boolean {
        return platform.is('cordova') && (platform.is('android') || platform.is('ios'));
    }
}